export const HEADER_TYPES = {
  FIELD: "field",
  GROUP: "group",
};

export const DATE_FORMATS = {
  DAY_NUMBER_MONTH_YEAR: "dddd DD MMMM YYYY",
};
